import type {WorkAttractiveConditionType} from '../../../core/entities/company/schema';

/**
 * workAttractiveConditionsを絞り込み条件に合致するものを先頭に並び替える
 * @param workAttractiveConditions - 企業の魅力的な働く条件一覧
 * @param filterAttractiveConditions - 絞り込み条件のID一覧（文字列の配列）
 * @returns 並び替えられた魅力的な働く条件一覧
 */
export const sortWorkAttractiveConditions = (
  workAttractiveConditions: WorkAttractiveConditionType[] | undefined,
  filterAttractiveConditions: string[] | number[],
): WorkAttractiveConditionType[] => {
  if (!workAttractiveConditions) {
    return [];
  }

  // filterAttractiveConditionsを文字列配列に統一
  const filterConditionsAsStrings = filterAttractiveConditions.map(String);

  return [
    // 絞り込み条件に合致するものを先頭に配置
    ...workAttractiveConditions.filter((condition) =>
      filterConditionsAsStrings.includes(String(condition.id)),
    ),
    // 絞り込み条件に合致しないものを後に配置
    ...workAttractiveConditions.filter(
      (condition) => !filterConditionsAsStrings.includes(String(condition.id)),
    ),
  ];
};
